const setupImageSwitch = (swatches) => {
	if (swatches.length > 0) {
		const updateSelectedClass = (selectedSwatch, relatedSwatches) => {
			relatedSwatches.forEach((swatch) => {
				swatch.classList.remove('is-selected')
			})

			selectedSwatch.classList.add('is-selected')
		}

		const updateTitle = (selectedSwatch, productCard) => {
			const titleElem = productCard.querySelector('.product-card__title a')
			const newTitle = selectedSwatch.dataset.variantTitle

			if (newTitle) {
				titleElem.textContent = newTitle
			}
		}

		const updateLink = (selectedSwatch, productCard) => {
			const linkElem = productCard.querySelector('.product-card__link')
			const newLink = selectedSwatch.dataset.variantUrl

			if (newLink) {
				linkElem.href = newLink
			}
		}

		const updatePrice = (selectedSwatch, productCard) => {
			const priceElem = productCard.querySelector('sale-price')
			const newPrice = selectedSwatch.dataset.variantPrice

			const compareAtPriceElem = productCard.querySelector('compare-at-price')
			const newCompareAtPrice = selectedSwatch.dataset.variantCompareAtPrice

			if (newPrice && priceElem) {
				const srOnlySpan = priceElem.querySelector('span.sr-only')
				if (srOnlySpan) {
					srOnlySpan.nextSibling.textContent = newPrice
				} else {
					priceElem.textContent = newPrice
				}
			}

			if (newCompareAtPrice && compareAtPriceElem) {
				const srOnlySpan = compareAtPriceElem.querySelector('span.sr-only')
				if (srOnlySpan) {
					srOnlySpan.nextSibling.textContent = newCompareAtPrice
				} else {
					compareAtPriceElem.textContent = newCompareAtPrice
				}
			}
		}

		const generateSrcset = (image, widths) => {
			// Handle relative URLs by resolving them against the current page URL
			const baseUrl = window.location.origin
			const imageUrl = new URL(image, baseUrl)
			return widths
				.map((width) => {
					imageUrl.searchParams.set('width', width.toString())
					return `${imageUrl.href} ${width}w`
				})
				.join(', ')
		}

		const updateCardImgs = (selectedSwatch, productCard) => {
			const primaryImageElem = productCard.querySelector(
				'.product-card__image--primary'
			)
			const newPrimaryImage = selectedSwatch.dataset.variantPrimaryImageSrc

			if (newPrimaryImage && primaryImageElem) {
				primaryImageElem.src = newPrimaryImage
				primaryImageElem.srcset = generateSrcset(
					newPrimaryImage,
					[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]
				)
			}

			const secondaryImageElem = productCard.querySelector(
				'.product-card__image--secondary'
			)

			const newSecondaryImage = selectedSwatch.dataset.variantHoverImageSrc

			if (newSecondaryImage && secondaryImageElem) {
				secondaryImageElem.src = newSecondaryImage
				secondaryImageElem.srcset = generateSrcset(
					newSecondaryImage,
					[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]
				)
			}
		}

		const updateBadges = (selectedSwatch, productCard) => {
			const soldOutBadgeElem = productCard.querySelector('sold-out-badge')
			if (!soldOutBadgeElem) return

			const selectedVariantSoldOut =
				selectedSwatch.dataset.variantSoldOut === 'true'

			if (selectedVariantSoldOut) {
				soldOutBadgeElem.classList.remove('hidden')
			} else {
				soldOutBadgeElem.classList.add('hidden')
			}
		}

		const handleSwatchClick = (e) => {
			const selectedSwatch = e.target
			const productCard = selectedSwatch.closest('product-card')
			const relatedSwatches = productCard.querySelectorAll(
				'.variant-picker .thumbnail-swatch'
			)

			updateSelectedClass(selectedSwatch, relatedSwatches)
			updateTitle(selectedSwatch, productCard)
			updateLink(selectedSwatch, productCard)
			updatePrice(selectedSwatch, productCard)
			updateCardImgs(selectedSwatch, productCard)
			updateBadges(selectedSwatch, productCard)
		}

		swatches.forEach((swatch) => {
			swatch.addEventListener('click', (e) => {
				handleSwatchClick(e)
			})
		})
	}
}

// Product recommendations are dynamically added with JS.
// To prevent race condition, initialize the product recommendation swatches individually
// after ensuring product recommendations are loaded.

// handle all swatches excluding from product recommendations
const allSwatches = document.querySelectorAll(
	'product-card .variant-picker .thumbnail-swatch'
)
const initialSwatches = Array.from(allSwatches).filter(
	(swatch) => !swatch.closest('product-recommendations')
)
setupImageSwitch(initialSwatches)

// handle product recommendations swatches
let maxIntervalCallsLeft = 10

const waitForProdRecSwatches = () => {
	maxIntervalCallsLeft--

	if (maxIntervalCallsLeft === 0) {
		clearInterval(prodRecSwatchesTimerId)
	}

	const productRecSwatches = document.querySelectorAll(
		'product-recommendations product-card .variant-picker .thumbnail-swatch'
	)

	if (productRecSwatches.length === 0) {
		return
	}

	setupImageSwitch(productRecSwatches)

	clearInterval(prodRecSwatchesTimerId)
}

prodRecSwatchesTimerId = setInterval(waitForProdRecSwatches, 200)
